import {
  MinusCircleOutlined,
  PlusOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Row,
  Select,
  Space,
  Input,
  Checkbox,
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
//import initialTermsCondition from '../../Common/intialTermsCondition';
import { ReactComponent as Back } from '../../Images/Back.svg';
import {
  fetchAlloyDropdown,
  resetAlloyList,
  resetCurrentAlloyListPage,
} from '../../slices/alloy';
import {
  fetchTemperDropdown,
  resetCurrentTemperPage,
  resetTempersList,
} from '../../slices/tempers';
import {
  createQuickCustomer,
  fetchCustomerConversionList,
  fetchCustomerDropdown,
  resetCurrentCustomerPage,
  resetCustomerList,
} from './../../slices/customer';
import {
  fetchDieProfileById,
  fetchDieProfileList,
  fetchDieProfileDropdown,
  resetCurrentDieProfilePage,
  resetDieProfileList,
  resetDieProfileData,
} from './../../slices/die-profile';
import { createQuotation } from '../../slices/quotation';
import {
  fetchConversionRateList,
  resetConversionRateList,
} from '../../slices/conversion-rate';
import { fetchNalcoRateForQuotation } from '../../slices/nalco-rate';
import { createNumberValidationRule } from '../../utils/CreateNumberValidationRule';
import { debounce } from 'lodash';
import { fetchPackingModeList, resetPackingModeData } from '../../slices/packing';
import { fetchjobWorkList, resetJobWorkList } from '../../slices/job-work';

const { Option } = Select;

export default function CreateQuotation() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [customerForm] = Form.useForm();
  const [btnLoading, setBtnLoading] = useState(false);
  const [searchTemper, setSearchTemper] = useState('');
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [searchAlloy, setSearchAlloy] = useState('');
  const [isCustomerModalVisible, setIsCustomerModalVisible] = useState(false);
  const [searchCustomer, setSearchCustomer] = useState('');

  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const { list: customerList } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { data: settingData } = useSelector(state => state.setting);
  const [editorValue, setEditorValue] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [hasErrors, setHasErrors] = useState(false);
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);
  const {
    list: alloyList,
    loading: alloyLoading,
    currentPage: alloyCurrentPage,
    hasMore: alloyHasMore,
  } = useSelector(state => state.alloy);
  const {
    jobWorkdata,
    loading: jobWorkLoading,
  } = useSelector(state => state.jobWork);
  const {
    list: temperList,
    loading: temperLoading,
    hasMore: temperHasMore,
  } = useSelector(state => state.temper);
  const [pricePerKg, setPricePerKg] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dispatch(
          fetchNalcoRateForQuotation(),
        );
        if (response) {
          setPricePerKg(response.payload.data.rate);
          form.setFieldsValue({
            quotation_details: [
              {
                price_per_kg: response.payload.data.rate,
              },
            ],
          });
        } else {
          console.error('Unexpected response structure:', response);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const terms =
      settingData?.term_and_condition_settings?.quotation_terms_and_conditions;

    if (terms) {
      setEditorValue(terms);

      // VERY IMPORTANT for AntD Form
      form.setFieldsValue({
        terms_and_condition: terms,
      });
    }
  }, [settingData, form]);

  useEffect(() => {
    if (selectedIndex === null) return;
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = item.wt_kg_p_mt || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      // const toleranceValue = form.getFieldValue('tolerance') || '';
      // const tolerancePercent = toleranceValue
      //   ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
      //   : 0;
      // const isPositive = toleranceValue.includes('+');
      // const isNegative = toleranceValue.includes('-');
      // let max_weight = netWeight;
      // let min_weight = netWeight;

      // if (tolerancePercent > 0) {
      //   if (isPositive && isNegative) {
      //     max_weight = netWeight * (1 + tolerancePercent / 100);
      //     min_weight = netWeight * (1 - tolerancePercent / 100);
      //   } else if (isPositive) {
      //     max_weight = netWeight * (1 + tolerancePercent / 100);
      //     min_weight = netWeight;
      //   } else if (isNegative) {
      //     min_weight = netWeight * (1 - tolerancePercent / 100);
      //     max_weight = netWeight;
      //   }
      // }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(2),
      };
      form.setFieldsValue({
        quotation_details: updatedDetails,
      });
    }
  }, [selectedIndex, form]);

  useEffect(() => {
    dispatch(fetchCustomerDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchAlloyDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchTemperDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchConversionRateList({ page: 1, pagesize: 1000 }));
    dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 1000 }));
    dispatch(fetchjobWorkList());
    dispatch(resetJobWorkList());
    dispatch(resetTempersList());
    dispatch(resetDieProfileList());
    dispatch(resetDieProfileData());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
    dispatch(resetConversionRateList());
    dispatch(resetPackingModeData());
  }, [dispatch, page, pagesize]);

  const handleFieldChange = (index, changedField) => {
    const workOrderDetails = form.getFieldValue('quotation_details') || [];
    const row = { ...workOrderDetails[index] } || {};
    const currentKg = row?.wt_kg_p_mt || 0;
    const length = parseFloat(row.length) || 0;
    const pieces = parseFloat(row.pieces) || 0;
    const net_weight = parseFloat(row.net_weight) || 0;

    let calculatedNetWeight = net_weight;
    let calculatedPieces = pieces;

    if (
      changedField === 'net_weight' &&
      net_weight > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedPieces = net_weight / (currentKg * (length / 1000));
    } else if (
      (changedField === 'pieces' || changedField === 'length') &&
      pieces > 0 &&
      length > 0 &&
      currentKg > 0
    ) {
      calculatedNetWeight = ((currentKg * length) / 1000) * pieces;
      calculatedNetWeight = Number(calculatedNetWeight).toFixed(3);
    }

    const updatedWorkOrderDetails = [...workOrderDetails];
    const updatedRow = {
      ...row,
      net_weight: calculatedNetWeight,
      wt_kg_p_mt: currentKg,
    };

    if (changedField === 'net_weight' || changedField === 'length') {
      updatedRow.pieces = Math.round(calculatedPieces);
    }

    updatedWorkOrderDetails[index] = updatedRow;
    form.setFieldsValue({
      quotation_details: updatedWorkOrderDetails,
    });
  };

  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      dispatch(resetCustomerList());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(resetCustomerList());
      dispatch(resetCurrentCustomerPage());
      dispatch(fetchCustomerDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };

  const fetchConversionData = async (customerId, dieId, index) => {
    try {
      const response = await dispatch(
        fetchCustomerConversionList({
          page: 1,
          pagesize: 10,
          customer_id: customerId,
          die_id: dieId,
        }),
      );

      const updatedQuotationDetails = [
        ...form.getFieldValue('quotation_details'),
      ];

      if (response && response.payload.data.length > 0) {
        const conversionValue = response.payload.data[0].conversion;
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: conversionValue,
          price_per_kg: pricePerKg,
        };
      } else {
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          conversion: '',
          price_per_kg: pricePerKg,
        };
      }

      form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    } catch (error) {
      console.error('Error fetching conversion data:', error);
    }
  };

  const handleChange = value => {
    setEditorValue(value);
  };

  const showCustomerModal = () => {
    setIsCustomerModalVisible(true);
  };

  const handleCustomerModalCancel = () => {
    setIsCustomerModalVisible(false);
    customerForm.resetFields();
  };

  const handleSaveCustomer = values => {
    dispatch(createQuickCustomer({ values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Customer Created Successfully!');
          handleCustomerModalCancel();
          dispatch(fetchCustomerDropdown({ page, pagesize }));
        }
      })
      .catch(error => {
        console.error('Error saving customer:', error);
      });
  };


  const handleDieProfileChange = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('quotation_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value?.value,
      conversion: '',
      customer_reference_no: '',
      wt_kg_p_mt: '',
    };
    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    setSelectedIndex(index);

    try {
      const response = await dispatch(fetchDieProfileById(value?.value)).unwrap();
      console.log("response", response);
      if (response?.success) {
        const customerRefNo =
          response?.data?.customer_reference_number || '';
        const wtKgPerMt = response?.data?.wt_kg_p_mt || '';

        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_no: customerRefNo,
          wt_kg_p_mt: wtKgPerMt,
        };

        form.setFieldsValue({
          quotation_details: updatedQuotationDetails,
        });

        const customerId = form.getFieldValue('customer');
        if (customerId) {
          await fetchConversionData(customerId, value?.value, index);
        }
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
  };

  const debouncedSearchDieProfile = debounce((value, dispatch) => {
    dispatch(resetDieProfileData());
    dispatch(
      fetchDieProfileDropdown({
        page: 1,
        pagesize: 50,
        search: value || '',
      }),
    );
  }, 300);

  const handleSearchDieProfile = value => {
    setSearchDieProfile(value);
    if (value) {
      debouncedSearchDieProfile(value, dispatch);
    } else {
      dispatch(resetDieProfileData());
      dispatch(fetchDieProfileDropdown({ page: 1, pagesize: 50 }));
    }
  };

  const onScrollDieProfile = event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollHeight - target.scrollTop - target.clientHeight < 50
    ) {
      const nextPage = dieProfileCurrentPage + 1;
      dispatch(
        fetchDieProfileDropdown({
          page: nextPage,
          pagesize: 50,
          search: searchDieProfile || '',
        }),
      );
    }
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);
    if (value) {
      dispatch(resetAlloyList());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloyDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const [searchUnitOfMeasurement, setSearchUnitOfMeasurement] = useState('');
  const handleChangeUnitOfMeasurement = value => {
    setSearchUnitOfMeasurement(value);
  };

  const handleSearchUnitOfMeasurement = value => {
    setSearchUnitOfMeasurement(value);
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloyDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };

  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      dispatch(resetTempersList());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTemperDropdown({ page: 1, pagesize: 10 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTemperDropdown({ page: alloyCurrentPage, pagesize: 10 }));
    }
  };


  useEffect(() => {
    fetchAlloyDropdown();
    fetchTemperDropdown();
    fetchDieProfileList();
    fetchConversionRateList();
    resetAlloyList();
    resetTempersList();
    resetCurrentDieProfilePage();
    resetDieProfileList();
    resetConversionRateList();
  }, []);

  const handleFinish = values => {
    setBtnLoading(true);
    const cleanedQuotationDetails = values.quotation_details.map(item => {
      const newItem = { ...item };
      delete newItem.wt_kg_p_mt;

      // Keep only checked Engineering options and their prices
      ["cutting", "machining", "deburring"].forEach(opt => {
        if (!newItem[opt]) {
          delete newItem[opt];
          //delete newItem[`${opt}_price`];
        }
      });

      ["anodising", "powder_coating", "pvdf"].forEach(opt => {
        if (!newItem[opt]) {
          delete newItem[opt];
          delete newItem[`${opt}_description`];
          //delete newItem[`${opt}_price`];
        }
      });

      // // Similarly, remove Laser Marking fields if not selected
      // if (!item.laser_marking_description && !item.laser_marking_price) {
      //   delete newItem.laser_marking_description;
      //   delete newItem.laser_marking_price;
      // }

      return newItem;
    });
    // values.inquiry_details = cleanedInquiryDetails;
    const formattedValues = {
      ...values,
      quotation_details: cleanedQuotationDetails,
    };
    values = formattedValues;
    values.quotation_date = dayjs(values.quotation_date).format('YYYY-MM-DD');
    dispatch(createQuotation({ values }))
      .unwrap()
      .then(result => {
        if (result?.success) {
          setBtnLoading(false);
          setHasErrors(false);
          message.success('Quotation Created Successfully!');
          navigate('/quotation-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        setHasErrors(true);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const handleCompanyNameChange = async value => {
    form.setFieldValue('customer', value);
    form.validateFields(['customer']);
    handleChangeCustomer(value);

    const quotationDetails = form.getFieldValue('quotation_details') || [];
    const updatedQuotationDetails = [...quotationDetails];
    updatedQuotationDetails.forEach((item, index) => {
      updatedQuotationDetails[index] = {
        ...item,
        conversion: '',
      };
    });

    form.setFieldsValue({ quotation_details: updatedQuotationDetails });
    for (let i = 0; i < updatedQuotationDetails.length; i++) {
      const dieId = updatedQuotationDetails[i]?.die_profile;
      if (dieId) {
        await fetchConversionData(value, dieId, i);
      }
    }
  };

  return (
    <>
      <div
        style={{
          position: 'sticky',
          zIndex: '1000',
          background: '#fff',
          padding: '16px',
          top: 0,
        }}
      >
        <div className="pagenamerow">
          <h2>Create Quotation</h2>
          <div className="bredcrumbwrp">
            <Link to="/quotation-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/quotation-list">Quotations</Link> },
                { title: 'Create Quotation' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          initialValues={{
            customer: null,
            quotation_date: dayjs(),
            remarks: null,
            terms_and_condition: '',
            project_name: null,
            packing_mode: [],
            quotation_details: [
              {
                die_profile: '',
                customer_reference_no: '',
                wt_kg_p_mt: '',
                alloy: '',
                temper: '',
                length: null,
                jobworks: null,
                conversion: null,
                out_source: null,
                finishing_price: null,
                price_per_kg: pricePerKg,
                unit_of_measurement: '',
                net_weight: null,
                pieces: null,
              },
            ],
          }}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="customer"
                  label="Company Name"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Space.Compact style={{ width: '100%' }}>
                    <AutoOpenSelect
                      value={searchCustomer}
                      placeholder="Please Select Company Name"
                      style={{ width: 'calc(100% - 40px)' }}
                      onChange={handleCompanyNameChange}
                      showSearch={true}
                      onSearch={handleSearchCustomer}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {[
                        ...new Map(
                          customerList.map(item => [item.id, item]),
                        ).values(),
                      ].map((el, index) => (
                        <Option
                          key={el.id}
                          value={el.id}
                          disabled={el.deleted === 1}
                        >
                          {el.customer_name}
                        </Option>
                      ))}
                    </AutoOpenSelect>
                    <Button
                      type="primary"
                      icon={<UserAddOutlined />}
                      onClick={showCustomerModal}
                    />
                  </Space.Compact>
                </Form.Item>
              </Col>

              <Modal
                title="Add New Customer"
                open={isCustomerModalVisible}
                onCancel={handleCustomerModalCancel}
                footer={[
                  <Button key="back" onClick={handleCustomerModalCancel}>
                    Cancel
                  </Button>,
                  <Button
                    type="primary"
                    onClick={() => customerForm.submit()}
                    htmlType="submit"
                    key="save"
                  >
                    Save Customer
                  </Button>,
                ]}
              >
                <Form
                  style={{ marginTop: '16px' }}
                  form={customerForm}
                  layout="vertical"
                  onFinish={handleSaveCustomer}
                >
                  <Row gutter={[16]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="customer_name"
                        label="Company Name"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter company name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Company Name"
                          onChange={e => {
                            const value = e.target.value;
                            customerForm.setFieldsValue({
                              customer_name: value,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="person_name"
                        label="Person Name"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid name',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter Name"
                          onChange={e => {
                            const value = e.target.value;
                            customerForm.setFieldsValue({
                              person_name: value,
                            });
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          {
                            type: 'email',
                            required: true,
                            message: 'Please enter a valid email',
                          },
                        ]}
                      >
                        <Input placeholder="Enter Email Address" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Mobile Number"
                        name={`phone_number`}
                        rules={[
                          {
                            required: true,
                            message: 'Please input your phone number!',
                          },
                        ]}
                      >
                        <PhoneInput
                          country={'in'}
                          enableSearch={true}
                          placeholder="Enter phone number"
                          onChange={value => value}
                          containerStyle={{ flex: 1 }}
                          inputStyle={{
                            width: '100%',
                            height: '36px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px',
                          }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Modal>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="quotation_date"
                  label="Today Date"
                  rules={[
                    { required: true, message: 'Please select quotation date' },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>

                <Form.Item
                  name="packing_mode"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select mode of packing' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                    loading={packingModeLoading}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="project_name"
                  label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter project name',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Project Name"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ project_name: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="quotation_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      className="rowItem mx-0"
                      gutter={[24, 24]}
                      align="middle"
                      key={key}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16}>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'die_profile']}
                              label="Section Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a section number',
                                },
                              ]}
                              style={{ marginBottom: 0 }}
                            >
                              <AutoOpenSelect
                                placeholder="Select Section Number"
                                labelInValue
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'die_profile',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'die_profile',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  handleDieProfileChange(value, name)
                                }
                                onSearch={handleSearchDieProfile}
                                allowClear
                                onClear={() => {
                                  dispatch(resetDieProfileData());
                                  dispatch(
                                    fetchDieProfileDropdown({
                                      page: 1,
                                      pagesize: 100,
                                    }),
                                  );
                                }}
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    dieProfileList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </AutoOpenSelect>
                            </Form.Item>
                            {form.getFieldValue([
                              'quotation_details',
                              name,
                              'customer_reference_no',
                            ]) && (
                                <div
                                  style={{
                                    marginTop: '4px',
                                    marginBottom: '16px',
                                    paddingLeft: '0px',
                                  }}
                                >
                                  <span style={{ fontSize: '12px', color: '#666' }}>
                                    <b>Customer Ref No:</b>{' '}
                                    <span style={{ color: '#333' }}>
                                      {form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'customer_reference_no',
                                      ])}
                                    </span>
                                  </span>
                                </div>
                              )}
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'alloy',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'alloy',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'alloy'],
                                    value,
                                  )
                                }
                                onSearch={handleSearchAlloy}
                                allowClear
                                showSearch={true}
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {alloyList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el?.alloy_code} - {el?.standard_name}
                                  </Option>
                                ))}
                                {alloyLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Temper"
                                loading={temperLoading}
                                onPopupScroll={onScrollTemper}
                                value={
                                  form.getFieldValue([
                                    'quotation_details',
                                    name,
                                    'temper',
                                  ])
                                    ? {
                                      value: form.getFieldValue([
                                        'quotation_details',
                                        name,
                                        'temper',
                                      ]),
                                      label: '',
                                    }
                                    : undefined
                                }
                                onChange={value =>
                                  form.setFieldValue(
                                    ['quotation_details', name, 'temper'],
                                    value,
                                  )
                                }
                                filterOption={(input, option) => {
                                  if (!input) return true;
                                  const optionText = (option?.children || '')
                                    .toString()
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  const inputText = input
                                    .replace(/\s+/g, '')
                                    .toLowerCase();
                                  return optionText.includes(inputText);
                                }}
                                onSearch={handleSearchTemer}
                                allowClear
                                showSearch={true}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {temperList.map(el => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    disabled={el.deleted === 1}
                                  >
                                    {el.temper_code_new} - {el.temper_code_old}
                                  </Option>
                                ))}
                                {temperLoading && <Option>Loading...</Option>}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length (mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter extrusion length',
                                }
                              ]}
                            >
                              <Input
                                placeholder="e.g. 6000"
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter pieces',
                                },
                                {
                                  pattern: /^[1-9]\d{0,5}$/,
                                  message: 'Pieces must be between 1 and 999999',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0"
                                onChange={() => {
                                  setTimeout(
                                    () => handleFieldChange(index, 'pieces'),
                                    0,
                                  );
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 7,
                                  maxAfterDecimal: 3,
                                  allowDecimal: true,
                                }),
                              ]}
                            >
                              <Input
                                placeholder="0.0"
                                onChange={e => {
                                  let value = e.target.value;
                                  if (
                                    /^\d{0,8}(\.\d{1,3})?$/.test(value) ||
                                    value === ''
                                  ) {
                                    handleFieldChange(
                                      index,
                                      'net_weight',
                                      value,
                                    );
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'unit_of_measurement']}
                              label="UOM"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select a measurement unit',
                                },
                              ]}
                            >
                              <AutoOpenSelect
                                placeholder="Select UOM"
                                showSearch={true}
                                value={searchUnitOfMeasurement}
                                onChange={handleChangeUnitOfMeasurement}
                                onSearch={handleSearchUnitOfMeasurement}
                                allowClear
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                <Option value="Kg">Kg</Option>
                                <Option value="Piece">Piece</Option>
                                <Option value="RMT">RMT</Option>
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'price_per_kg']}
                              label="Price per kg"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Price per kg',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                                {
                                  pattern: /^(0|[1-9]\d*)(\.\d{1,2})?$/,
                                  message: 'Enter valid conversion (up to 2 decimals)',
                                },
                              ]}
                            >
                              <Input placeholder="0.00" />
                            </Form.Item>
                          </Col>

                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobworks']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select surface finish',
                                },
                              ]}
                              label="Surface finish"
                            >
                              <AutoOpenSelect
                                placeholder="Select Surface finish"
                                mode="multiple"
                                allowClear
                                showSearch
                                loading={jobWorkLoading}
                                disabled={jobWorkLoading}
                                notFoundContent={jobWorkLoading ? "Loading surface finishes..." : "No options found"}
                                value={form.getFieldValue(['quotation_details', name, 'jobworks'])}
                                onChange={(value) => {
                                  const selectedItems = jobWorkdata?.filter(item => value.includes(item.id));
                                  const selectedNames = selectedItems.map(item => item.name);



                                  // const laserMarkingId = jobWorkdata?.find(item => item.name === "Laser marking")?.id;
                                  const engineeringId = jobWorkdata?.find(item => item.name === "Engineering")?.id;
                                  const surfaceTreatmentId = jobWorkdata?.find(item => item.name === "Surface treatment")?.id;

                                  const details = form.getFieldValue("inquiry_details") || [];
                                  if (!details[index]) return;
                                  const newDetails = [...details];

                                  // Delete Laser Marking fields if deselected
                                  // if (!value.includes(laserMarkingId)) {
                                  //   delete newDetails[index].laser_marking_description;
                                  //   delete newDetails[index].laser_marking_price;
                                  // }

                                  // Delete Engineering-related fields if deselected
                                  if (!value.includes(engineeringId)) {
                                    ["cutting", "machining", "deburring"].forEach(opt => {
                                      if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                      //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                    });
                                  }

                                  // Delete Surface Treatment -related fields if deselected
                                  if (!value.includes(surfaceTreatmentId)) {
                                    ["anodising", "powder_coating", "pvdf"].forEach(opt => {
                                      if (newDetails[index][opt] !== undefined) delete newDetails[index][opt]; // remove boolean
                                      if (newDetails[index][`${opt}_description`] !== undefined) delete newDetails[index][`${opt}_description`]; // remove description
                                      //if (newDetails[index][`${opt}_price`] !== undefined) delete newDetails[index][`${opt}_price`]; // remove price
                                    });
                                  }

                                  form.setFieldsValue({ inquiry_details: newDetails });
                                }}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {jobWorkdata?.map(item => (
                                  <Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Option>
                                ))}
                              </AutoOpenSelect>



                            </Form.Item>
                          </Col>

                          <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.quotation_details?.[index]?.jobworks !==
                              currentValues.quotation_details?.[index]?.jobworks
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const selectedSurfaceFinish = getFieldValue(["quotation_details", index, "jobworks"]) || [];

                              const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                              // Example: show conditional field if Laser Marking selected
                              const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                              const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                              return (
                                <>
                                  {/* --- Engineering Fields --- */}
                                  {hasEngineering && (
                                    <>
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.cutting !== curr.quotation_details?.[index]?.cutting ||
                                          prev.quotation_details?.[index]?.machining !== curr.quotation_details?.[index]?.machining ||
                                          prev.quotation_details?.[index]?.deburring !== curr.quotation_details?.[index]?.deburring
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const cutting = getFieldValue(['quotation_details', index, 'cutting']);
                                          const machining = getFieldValue(['quotation_details', index, 'machining']);
                                          const deburring = getFieldValue(['quotation_details', index, 'deburring']);

                                          return (
                                            <>
                                              <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                                <Form.Item
                                                  name={[name, "cutting"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>Cutting</Checkbox>
                                                </Form.Item>

                                                <Form.Item
                                                  name={[name, "machining"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>Machining</Checkbox>
                                                </Form.Item>

                                                <Form.Item
                                                  name={[name, "deburring"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>Deburring</Checkbox>
                                                </Form.Item>
                                              </Col>

                                              {cutting && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Cutting Price"
                                                    name={[name, 'cutting_price']}
                                                    rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {machining && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Machining Price"
                                                    name={[name, 'machining_price']}
                                                    rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {deburring && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Deburring Price"
                                                    name={[name, 'deburring_price']}
                                                    rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                  >
                                                    <Input placeholder="0.0" />
                                                  </Form.Item>
                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                  {/* --- Surface Treatment Fields --- */}
                                  {hasSurfaceTreatment && (
                                    <>


                                      {/* Nested conditional price fields */}
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.quotation_details?.[index]?.anodising !== curr.quotation_details?.[index]?.anodising ||
                                          prev.quotation_details?.[index]?.powder_coating !== curr.quotation_details?.[index]?.powder_coating ||
                                          prev.quotation_details?.[index]?.pvdf !== curr.quotation_details?.[index]?.pvdf
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const anodising = getFieldValue(["quotation_details", index, "anodising"]);
                                          const powder_coating = getFieldValue(["quotation_details", index, "powder_coating"]);
                                          const pvdf = getFieldValue(["quotation_details", index, "pvdf"]);
                                          return (
                                            <>
                                              <Col xs={12} md={8} xl={6} xxl={6} style={{ marginTop: '24px' }}>
                                                <Form.Item
                                                  name={[name, "anodising"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>Anodising</Checkbox>
                                                </Form.Item>

                                                <Form.Item
                                                  name={[name, "powder_coating"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>Powder Coating</Checkbox>
                                                </Form.Item>

                                                <Form.Item
                                                  name={[name, "pvdf"]}
                                                  valuePropName="checked"
                                                  noStyle
                                                >
                                                  <Checkbox>PVDF</Checkbox>
                                                </Form.Item>
                                              </Col>
                                              {anodising && (
                                                <>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Description"
                                                      name={[name, "anodising_description"]}
                                                      rules={[{ required: true, message: "Enter Anodising Description" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Price"
                                                      name={[name, "anodising_price"]}
                                                      rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}

                                              {powder_coating && (
                                                <>
                                                  <Col xs={12} md={8} xl={4}>
                                                    <Form.Item
                                                      label="Powder Coating Description"
                                                      name={[name, "powder_coating_description"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Description" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Powder Coating Price"
                                                      name={[name, "powder_coating_price"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}

                                              {pvdf && (
                                                <>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="PVDF Description"
                                                      name={[name, "pvdf_description"]}
                                                      rules={[{ required: true, message: "Enter PVDF Description" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Description" />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="PVDF Price"
                                                      name={[name, "pvdf_price"]}
                                                      rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Price" />
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginTop: '30px',
                                }}
                              />
                            )}
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            dispatch(resetDieProfileData());
                            dispatch(
                              fetchDieProfileDropdown({ page: 1, pagesize: 100 }),
                            );
                            setSearchDieProfile('');
                            add({ price_per_kg: pricePerKg });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item
                name="terms_and_condition"
                label="Terms & Condition"
                rules={[
                  { required: true, message: 'Terms & Condition is required' },
                ]}
                valuePropName="content"
              >
                <ReactQuill
                  value={editorValue}
                  onChange={handleChange}
                  theme="snow"
                  modules={{
                    toolbar: [
                      [{ header: '1' }, { header: '2' }, { font: [] }],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['bold', 'italic', 'underline'],
                      [{ align: [] }],
                      ['link', 'image'],
                      ['blockquote', 'code-block'],
                    ],
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="remarks" label="Remarks">
                <Input.TextArea
                  placeholder="Enter Remarks"
                  onChange={e => {
                    const value = e.target.value;
                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());
                    form.setFieldsValue({ remarks: formattedValue });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
              disabled={hasErrors}
            >
              Create Quotation
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
